import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { setDeleteCollectionModal } from "./DeleteCollectionModalSlice";
import {
    useDeleteCollectionMutation,
    useLazyGetCollectionsQuery,
} from "../../pages/collectionsPage/CollectionsSlice";
import { JSX, useState } from "react";
import { Modal, Button } from "@hatch-digital-nl/bravilor-storybook";
import { useStringTranslation } from "../../common/hooks/useStringTranslation";

export const DeleteCollectionModalContainer = (): JSX.Element => {
    const dispatch = useAppDispatch();
    const { t } = useStringTranslation();

    const { collections } = useAppSelector((state) => state.collections);
    const { collectionId } = useAppSelector(
        (state) => state.deleteCollectionModal,
    );

    const [loading, setLoading] = useState<boolean>(false);
    const [deleteCollectionTrigger] = useDeleteCollectionMutation();
    const [collectionTrigger] = useLazyGetCollectionsQuery();

    const collectionName =
        collections.find((item: { id: number }) => item.id === collectionId)
            ?.name || "";

    const handleClose = (): void => {
        dispatch(
            setDeleteCollectionModal({
                showPopup: false,
            }),
        );
    };

    return (
        <Modal onClose={handleClose} loading={loading}>
            <header className="c-modal__header">
                <h2>{t("do-you-want-to-delete-this-item") ?? ""}</h2>
            </header>
            <div className="c-modal__body">
                <p>
                    {t("are-you-sure-you-want-to-delete-the") +
                        " " +
                        collectionName +
                        " " +
                        t("collection") +
                        "?"}
                </p>

                <div className="c-modal__body__buttons">
                    <Button
                        variant={"primary"}
                        onClick={() => {
                            setLoading(true);
                            deleteCollectionTrigger(collectionId).then(() => {
                                collectionTrigger().then(() => {
                                    setLoading(false);
                                    dispatch(
                                        setDeleteCollectionModal({
                                            showPopup: false,
                                        }),
                                    );
                                });
                            });
                        }}
                    >
                        <span>{t("yes-im-sure") ?? ""}</span>
                    </Button>
                    <Button
                        variant={"secondary"}
                        onClick={() => {
                            dispatch(
                                setDeleteCollectionModal({
                                    showPopup: false,
                                }),
                            );
                        }}
                    >
                        <span>{t("cancel") ?? ""}</span>
                    </Button>
                </div>
            </div>
        </Modal>
    );
};
